<!--
 * @Description: 
 * @Date: 2021-02-06 14:51:38
-->
<template>
  <div>
    <div v-if="livingStore.isDesktop" class="living-title">
      <div
        v-if="livingStore.livingConf.isShowPerson"
        style="display: flex; align: center"
      >
        <h5>{{ livingStore.detail.courseName }}</h5>
        <img class="pic" :src="require('@/assets/data.gif')" alt />
        <p>{{ users }} 人正在观看</p>
      </div>
      <div class="center">
        <div
          @mouseenter.prevent="itemmouseenter"
          @mouseleave.prevent="itemMouseout"
          style="position: relative"
        >
          <div v-show="isShow" class="toast">
            <img
              style="width: 70px; height: 70px; margin-left: 11px"
              class="ewm"
              alt="ewm"
              :src="getQrcodeUrl(href)"
            />
            <div style="display: inline-grid; margin-left: 20px">
              <span
                style="
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #027cfa;
                  line-height: 14px;
                "
              >
                扫码进入移动观看页
              </span>
              <span
                style="
                  margin-top: 7px;
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #777889;
                  line-height: 14px;
                "
              >
                推荐使用微信扫一扫
              </span>
            </div>
          </div>
          <div style="width: 200px; pointer-events: none">
            <img src="../../../static/img/shouji.png" />
            手机观看
          </div>
        </div>
        <div
          style="margin-left: auto"
          v-if="livingStore.livingConf.signTimeSetting > 0"
        >
          <van-button
            :disabled="text == '已签到'"
            @click="sign"
            type="warning"
            size="mini"
          >
            {{ text }}
          </van-button>
        </div>
      </div>
    </div>
    <div
      class="living-title"
      v-if="livingStore.livingConf.isShowPerson && !livingStore.isDesktop"
    >
      <h5>{{ livingStore.detail.courseName }}</h5>
      <div style="display: flex; align-items: center">
        <p v-if="livingStore.livingConf.isShowPerson && !isEnd">
          <img :src="require('@/assets/data.gif')" alt style="width: 0.35rem" />
          {{ users }} 人正在观看
        </p>
        <div
          style="margin-left: auto"
          v-if="livingStore.livingConf.signTimeSetting > 0"
        >
          <van-button
            :disabled="text == '已签到'"
            @click="sign"
            type="warning"
            size="mini"
          >
            {{ text }}
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getQrcodeUrl } from '@/utils/tools';
import { isSignInAble, signIn } from '@/api/ajax';
export default {
  name: 'LivingTitle',
  inject: ['livingStore'],
  data() {
    return {
      getQrcodeUrl,
      href: window.location.href,
      text: '签到',
      isShow: false,
      time: new Date().getTime()
    };
  },
  components: {},
  watch: {},
  methods: {
    itemmouseenter() {
      this.isShow = true;
    },
    itemMouseout() {
      this.isShow = false;
    },
    isSignInAble() {
      isSignInAble({ courseId: this.$route.params.id }).then(res => {
        this.text = res.data.data.isSignInAble == 0 ? '已签到' : '签到';
      });
    },
    sign() {
      if (this.isStart) {
        this.$toast('直播未开始');
        return;
      }
      if (this.isEnd) {
        this.$toast('直播已结束');
        return;
      }
      if (
        (new Date().getTime() - this.time) / 1000 / 60 >=
        this.livingStore.livingConf.signTimeSetting
      ) {
        signIn({ courseId: this.livingStore.livingConf.courseId })
          .then(res => {
            this.text = '已签到';
            this.$toast('签到成功');
          })
          .catch(e => {
            console.log(e);
          });
      } else {
        this.$toast(
          `至少观看${this.livingStore.livingConf.signTimeSetting}分钟才可签到`
        );
      }
    }
  },
  created() {
    this.isSignInAble();
  },
  computed: {
    users() {
      const { livingStore } = this;
      let {
        basePersonNum,
        personMulti,
        isPersonMulti,
        showPersonType,
        isBasePerson
      } = livingStore.livingConf;
      // 使用实际数据还是总人数
      let users =
        showPersonType === 1 ? livingStore.totalUsers : livingStore.realUsers;
      return (
        // 基数 + 用户数 * 倍数
        ((isBasePerson && basePersonNum) || 0) +
        users * ((isPersonMulti && personMulti) || 1)
      );
    },
    isStart() {
      return this.livingStore.livingStatus === 1;
    },
    isEnd() {
      return this.livingStore.livingStatus === 3;
    }
  }
};
</script>

<style scoped lang="scss">
.toast {
  display: flex;
  align-items: center;
  z-index: 999;
  width: 244px;
  height: 112px;
  background: #ffffff;
  box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.16);
  border: 1px solid #cecece;
  position: absolute;
  top: 30px;
  border-radius: 4px;
}
.living-title {
  @media (min-width: 600px) {
    padding: 0px !important;
  }
  align-items: center;
  padding: 0.2rem 0.37rem;
  .pic {
    @media (min-width: 600px) {
      width: 25px;
      height: 18px;
      margin-right: 5px;
    }
    width: 0.5rem;
    height: 0.45rem;
    margin-left: 0.2rem;
    margin-right: 0.1rem;
  }
  h5 {
    @media (min-width: 600px) {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 18px;
      display: flex;
      margin-bottom: 0px;
      margin-right: 15px;
    }
    font-size: 0.37rem;
  }
}
.center {
  margin: 10px 0px 20px;
  display: flex;
  @media (max-width: 600px) {
    justify-content: flex-end;
  }
  justify-content: space-between;
  align-items: center;
}
</style>
